var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5 min-h-20 flex flex-row items-center space-x-4"},[_c('div',{staticClass:"w-10 h-10 flex-shrink-0"},[_vm._t("icon")],2),_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }